import { IManager } from '@/models/admins.model';
import { IPagination, IPaginationDTO } from '@/models/pagination.model';
import { IStoreItem } from './products.model';

export enum PartnersEndpoints {
  PARTNERS_LIST = '/partners',
  CATEGORY_MANAGERS = '/partners/category-managers',
}

// ----------------- DTOs ----------------

export interface IGetPartnersListDTO extends Partial<IPaginationDTO> {
  email?: string;
  active?: '0' | '1';
  limit?: number;
  hidden?: '0' | '1';
  phone?: string;
  verified_at?: string;
  last_login_at?: string;
  store_title?: string;
  title?: string;
}

export interface ICreatePartnerDTO {
  first_name: string;
  middle_name: string;
  last_name: string;
  title: string;
  email: string;
  phone: string;

  legal_type: 'fop' | 'tov';
  ownership_form: 'legal_entity' | 'fop';
  edrpou?: string;
  drfo?: string;
  is_vat_payer: boolean;
  ipn?: string;
  tax_type: 'simple' | 'general';

  legal_address: string;
  physical_address: string;
  subscriber_full_name: string;

  bank_accounts: IPartnerBankAccountDTO[];

  has_no_accountant: boolean;
  accountant_first_name?: string;
  accountant_last_name?: string;
  accountant_middle_name?: string;
  accountant_email?: string;
  accountant_phone?: string;

  category_manager_id?: string | null;
  document?: string;
}

export interface IPartnerBankAccountDTO {
  bank_name: string;
  mfo: string;
  iban: string;
}

export interface IUpdatePartnerDTO extends Partial<ICreatePartnerDTO> {
  id: string;
}

// ------------ Responses --------------

export interface IPartnerBankAccount {
  id: string;
  bank_name: string;
  mfo: string;
  iban: string;
  sort_order: number;
}

export interface IPartnerProfile {
  id: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  title: string;
  email: string;
  phone: string;
  active: boolean;
  hidden: boolean;
  created_at: string;
  verified_at: string;
  last_login_at: string | null;
  updated_at: string;
  legal_type: string;
  invitation_expired?: boolean | null;
  subscriber_full_name?: string;
  organization_tax_code?: string;
  organization_tax_type?: string;
  document?: string;
  legal_address?: string;
  physical_address?: string;
  iban?: string;
  bank_name?: string;
  tax_type?: string;
  store?: IStoreItem;
  category_manager?: IManager | null;
  ipn?: string | null;
  ownership_form?: 'legal_entity' | 'fop' | null;
  edrpou?: string | null;
  drfo?: string | null;
  is_vat_payer?: boolean | null;
  bank_accounts?: IPartnerBankAccount[];
  has_no_accountant?: boolean | null;
  accountant_first_name?: string | null;
  accountant_last_name?: string | null;
  accountant_middle_name?: string | null;
  accountant_email?: string | null;
  accountant_phone?: string | null;
}

export interface IPartnerProfileResponse {
  data: IPartnerProfile;
}

export interface IPartnerAuthData {
  data: {
    access_token: string;
  };
}

export interface IPartnersListResponse {
  data: IPartnerProfile[];
  meta: IPagination;
}
